// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.policies {
  background: var(--bg-light);
}

.policies__head {
  margin-bottom: 40px;
}

.policies__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 22px;
}

.policy-card {
  display: block;
  width: 100%;
  text-align: left;
  font-family: var(--font-body);
  background: #fff;
  border-radius: var(--radius-lg);
  padding: 30px;
  border: 1px solid var(--border-soft);
  border-top: 3px solid transparent;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.policy-card--teal {
  border-top-color: var(--teal);
}

.policy-card--amber {
  border-top-color: var(--amber);
}

.policy-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-md);
}

.policy-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 13px;
  margin-bottom: 16px;
}

.policy-card--teal .policy-card__icon {
  color: var(--teal-dark);
  background: var(--teal-tint);
}

.policy-card--amber .policy-card__icon {
  color: var(--amber-dark);
  background: var(--amber-tint);
}

.policy-card h3 {
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 8px;
}

.policy-card p {
  font-size: 13.5px;
  margin-bottom: 18px;
}

.policy-card__link {
  font-family: var(--font-display);
  font-size: 13px;
  font-weight: 700;
}

.policy-card--teal .policy-card__link {
  color: var(--teal-dark);
}

.policy-card--amber .policy-card__link {
  color: var(--amber-dark);
}

@media (max-width: 1100px) {
  .policies__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .policies__grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Policies.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".policies {\n  background: var(--bg-light);\n}\n\n.policies__head {\n  margin-bottom: 40px;\n}\n\n.policies__grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 22px;\n}\n\n.policy-card {\n  display: block;\n  width: 100%;\n  text-align: left;\n  font-family: var(--font-body);\n  background: #fff;\n  border-radius: var(--radius-lg);\n  padding: 30px;\n  border: 1px solid var(--border-soft);\n  border-top: 3px solid transparent;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.policy-card--teal {\n  border-top-color: var(--teal);\n}\n\n.policy-card--amber {\n  border-top-color: var(--amber);\n}\n\n.policy-card:hover {\n  transform: translateY(-6px);\n  box-shadow: var(--shadow-md);\n}\n\n.policy-card__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 13px;\n  margin-bottom: 16px;\n}\n\n.policy-card--teal .policy-card__icon {\n  color: var(--teal-dark);\n  background: var(--teal-tint);\n}\n\n.policy-card--amber .policy-card__icon {\n  color: var(--amber-dark);\n  background: var(--amber-tint);\n}\n\n.policy-card h3 {\n  font-size: 17px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.policy-card p {\n  font-size: 13.5px;\n  margin-bottom: 18px;\n}\n\n.policy-card__link {\n  font-family: var(--font-display);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.policy-card--teal .policy-card__link {\n  color: var(--teal-dark);\n}\n\n.policy-card--amber .policy-card__link {\n  color: var(--amber-dark);\n}\n\n@media (max-width: 1100px) {\n  .policies__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .policies__grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
